// extracted by mini-css-extract-plugin
export var deleteModal = "_gq-0";